module.exports = __webpack_public_path__ + "static/media/casey-fraser.5d226ff7.jpg";